<template>
  <div>
    <navigation-main bg="true" />

    <div class="main-content">
      <div class="" data-spy="scroll" data-target="#mainNav" data-offset="75">
        <main role="main" class="flex-grow-1 overflow-auto">
          <div id="content">

            <!--
            <b-carousel
              id="carousel-fade"
              style="text-shadow: 0px 0px 2px #000"
              class="main-carousel"
              fade
              indicators
              img-width="1024"
            >
              <b-carousel-slide class="test" img-src="/imgs/GOPR0594_frame_001038_teaser.png">
                <div
                  class="row h-100 align-items-center justify-content-center text-center textbox-main"
                >
                  <div class="col-lg-10 align-self-end">
                    <h1 class="text-uppercase text-white font-weight-bold">
                      ACDC Dataset
                    </h1>
                    <hr class="divider m-auto" />
                  </div>
                  <div class="col-lg-8 align-self-baseline">
                    <p class="text-white font-weight-light mb-5">
                      Semantic pixel-level annotations for
                      19 Cityscapes classes in adverse conditions
                    </p>
                    <a
                      class="btn btn-primary btn-xl js-scroll-trigger"
                      href="#about"
                      >Overview</a
                    >
                  </div>
                </div>
              </b-carousel-slide>
              <b-carousel-slide img-src="/imgs/GP040176_frame_000464_teaser.png">
                <div
                  class="row h-100 align-items-center justify-content-center text-center textbox-main"
                >
                  <div class="col-lg-10 align-self-end">
                    <h1 class="text-uppercase text-white font-weight-bold">
                      ACDC Dataset
                    </h1>
                    <hr class="divider m-auto" />
                  </div>
                  <div class="col-lg-8 align-self-baseline">
                    <p class="text-white font-weight-light mb-5">
                      4006 annotated images evenly distributed
                      between fog, nighttime, rain and snow
                    </p>
                    <a
                      class="btn btn-primary btn-xl js-scroll-trigger"
                      href="#about"
                      >Overview</a
                    >
                  </div>
                </div>
              </b-carousel-slide>
              <b-carousel-slide img-src="/imgs/GP010477_frame_000127_teaser.png">
                <div
                  class="row h-100 align-items-center justify-content-center text-center textbox-main"
                >
                  <div class="col-lg-10 align-self-end">
                    <h1 class="text-uppercase text-white font-weight-bold">
                      ACDC Dataset
                    </h1>
                    <hr class="divider m-auto" />
                  </div>
                  <div class="col-lg-8 align-self-baseline">
                    <p class="text-white font-weight-light mb-5">
                      Corresponding images of the same scenes taken
                      under normal conditions &middot; Invalid masks distinguishing
                      between intra-image regions of clear and uncertain
                      content
                    </p>
                    <a
                      class="btn btn-primary btn-xl js-scroll-trigger"
                      href="#about"
                      >Overview</a
                    >
                  </div>
                </div>
              </b-carousel-slide>
              <b-carousel-slide class="test" img-src="/imgs/GOPR0573_frame_000273_teaser.png">
                <div
                  class="row h-100 align-items-center justify-content-center text-center textbox-main"
                >
                  <div class="col-lg-10 align-self-end">
                    <h1 class="text-uppercase text-white font-weight-bold">
                      ACDC Dataset
                    </h1>
                    <hr class="divider m-auto" />
                  </div>
                  <div class="col-lg-8 align-self-baseline">
                    <p class="text-white font-weight-light mb-5">
                      Benchmark suite and evaluation server for
                      standard semantic segmentation and
                      uncertainty-aware semantic segmentation
                    </p>
                    <a
                      class="btn btn-primary btn-xl js-scroll-trigger"
                      href="benchmarks"
                      >Benchmarks</a
                    >
                  </div>
                </div>
              </b-carousel-slide>
            </b-carousel>
            -->

            <!-- About-->
            <section class="page-section" id="about">
              <div class="container">
                <div class="row ">
                  <div class="col-lg-12">
                    <div>
                      <h2
                        class="text-black mt-0"
                        style="color:black !important;"
                      >
                        EFCL Sensor Fusion Dataset
                      </h2>
                      <hr class="divider dark" style="max-width: 100%" />
                    </div>
                    <p>
                      Under the umbrella of the
                      <a href="https://muses.ethz.ch"
                        >ETH Future Computing Laboratory (EFCL)</a
                      >, our research group from the 
                      <a href="https://vision.ee.ethz.ch"
                        >Computer Vision Lab, ETH Zürich,</a
                      > aims to develop computer vision technologies that enable the recognition
                      of semantic content in street scene images under variable and adverse
                      visual conditions. In particular, we explore how complementary sensor
                      information can be fused depending on the visual conditions at hand. As
                      part of this work, we record an automotive dataset in the greater area of 
                      Zürich, Switzerland. 
                    </p>
                    <p>
                      The time and location of all our data acquisition drives 
                      are posted in advance on our
                      <a href="/efcl/announcements">announcements page</a>. Our sensor setup includes 
                      an RGB camera, an event camera, a MEMS lidar, a spinning radar, and a GNSS,
                      mounted in a weatherproof rig on top of a dedicated car. For more details
                      about the setup, check out the <a href="/efcl/materials#technicalReport">technical report</a>.
                    </p>
                    <!--
                    <p>ACDC supports two tasks:</p>
                    <ol class="ml-3">
                      <li>
                        standard semantic segmentation
                      </li>
                      <li>
                        uncertainty-aware semantic segmentation
                      </li>
                    </ol>
                    <a
                      class="btn btn-secondary btn-xl js-scroll-trigger"
                      href="download"
                      >Get Started!</a
                    >
                    -->
                  </div>
                </div>
              </div>
            </section>

            <section class="">
              <div class="container">
                <img src="/imgs/overlay.png" alt="" style="width: 100%; object-fit: contain"/>
              </div>
            </section>

            <!--
            <section class="">
              <div class="container">
                <div class="row mt-3">
                  <div class="col-lg-12 mt-2">
                    <div>
                      <h2
                        class="text-black mt-0"
                        style="color:black !important;"
                      >
                        License
                      </h2>
                    </div>
                    <p class="mb-4">
                      Our autonomous driving dataset will be made freely available to
                      academic and non-academic entities for non-commercial
                      purposes such as academic research, teaching, scientific
                      publications, or personal experimentation. Permission will be
                      granted to use the data given that you agree to our
                      <a href="license"
                        >license terms</a
                      >.
                    </p>
                  </div>
                </div>
              </div>
            </section>
            -->

          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../style/_variables.scss";
@import "../style/mixins.scss";

.carousel-item img {
  height: calc(100vh - 60px) !important;
  object-fit: cover !important;
  filter: blur(2px);
}

.textbox-main {
  background-color: #02000000;
}

.carousel-caption {
  bottom: 50% !important;
}
</style>
<script>
import { mapState } from "vuex";
import NavigationMain from "@/views/navigation/navigation-main";

export default {
  components: { NavigationMain },
  computed: {
    ...mapState({
      account: state => state.account
    })
  }
};
</script>
